import { dwgl } from '@/axios'
import Page from '@/components/page.vue'
import { Message } from 'element-ui'
import DelData from '@/components/delToast.vue'
import Addperson from '../components/addPerson.vue'
import Dwdf from '../components/dwdf.vue'
import {bsid } from '@/common/common.js'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id: this.$store.state.user.userinfo.id,
				flag: this.$store.state.user.userinfo.flag,
				year: new Date().getFullYear(),
				page:1,
				status:1//1党员2：党务
			},
			dwFliesSub:{
				files:[],
				user_id:this.$store.state.user.userinfo.id,
				status:1
			},
			shuoming:"最终评选结果由党委打分决定，90分以上（含90分）评定为“优秀党员”，90分以下“本期落选。",
			tableData:[],
			totalPage:0,
			tableHeader:[]
		}
	},
	components:{Page,DelData,Addperson,Dwdf},
	mounted() {
		that.dataList();
		that.typeList();
		that.dwFiles();
	},
	created() {
		that = this;
	},
	methods:{
		// 数据列表
		dataList(){
			dwgl.goodMemberList(that.getdata).then(res => {
				if(res.code == 200){
					if(res.data.pagedata.length>0){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 分页查询
		changedata(current){
			that.getdata.page = current;
			that.dataList();
		},
		// 详情
		godetail(data){
			that.$router.push({
				path:'/fbtz_detail',
				query:{
					id:data.tid
				}
			})
		},
		// 删除
		del(data){
			that.$refs.delDatas.showToast(res => {
				if(res){
					dwgl.delGoodMember({
						id:data.id
					}).then(res => {
						if(res.code == 200){
							Message.success('删除成功!');
							that.getdata.page = 1;
							that.dataList()
						}else{
							Message.error(res.msg);
						}
					})
				}
			})
		},
		// 评分项
		typeList(){
			dwgl.goodMemberType({
				status:1,
				user_id:that.getdata.user_id
			}).then(res => {
				if(res.code == 200){
					that.tableHeader = res.data;
				}else{
					Message.error(res.msg);
				}
			})
		},
		// 文件上传限制
		limitFiles(file){
			var isJPG = file.type === 'application/pdf' 
				|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
				|| file.type === 'application/msword';
			var isLt2M = file.size / 1024 / 1024 < 20;
			if (!isJPG) {
				Message.error('仅支持pdf、doc、docx文件');
				return false;
			}
			if (!isLt2M) {
				Message.error('上传文件大小不能超过 20MB!');
				return false;
			}
			if(that.dwFliesSub.files.length>=4){
				Message.error("最多可传4个文件")
				return false;
			}
		},
		// 上传文件成功
		success1(res, file) {
			if(res.code == 200){
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					url:res.data.src
				}
				that.dwFliesSub.files = [];
				that.dwFliesSub.files.push(data);
				that.subDwFiles();
			}else{
				Message.error('上传失败');
			}
		},
		// 上传进度
		uploadProcess(event, file, fileList) {
			const loading = this.$loading({
				lock: true,
				text: '上传中请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			});
			if(Math.floor(event.percent) == 100){
				loading.close();
			}
		},
		// 提交党委文件
		subDwFiles(){
			dwgl.goodMemberAddTypeFile(that.dwFliesSub).then(res => {
				if(res.code == 200){
					that.dwFiles();
					that.dwFliesSub.files = [];
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 党委上传文件列表
		dwFiles(){
			that.dwFliesSub.files = [];
			dwgl.goodMemberTypeFileList({
				user_id:that.$store.state.user.userinfo.dwid,
				status:1//1党员2：党务
			}).then(res => {
				if(res.code == 200){
					that.dwFliesSub.files = res.data;
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 删除党委上传文件
		delDwFiles(id){
			dwgl.delGoodMemberTypeFile({
				id:id
			}).then(res => {
				if(res.code == 200){
					that.dwFiles();
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 支部下载党委上传的文件
		zbDownloadFile(url){
			if(url){
				location.href = url;
			}else{
				Message({
					type:"error",
					message:"下载失败"
				})
			}
		},
		// 导出表格
		putOut(){
			if(that.tableData.length==0){
				Message.error("无可导出数据")
			}else{
				dwgl.exportPartyOrgan({
					user_id:that.$store.state.user.userinfo.id,
					sign:14,
					status:1,//1党员2：党务工作者
				});
			}
		}
	}
}